import { Hosts } from "./host-objects";

export type NavSection =
  | "orders"
  | "roomService"
  | "timetable"
  | "routes"
  | "map"
  | "services"
  | "hotel"
  | "media"
  | "administration";

export interface INavbarItemConfig {
  hidden?: boolean;
  hiddenChildren?: string[];
  singleChild?: string;
}

export interface IHostFeatureConfig {
  navbar?: Partial<Record<NavSection, INavbarItemConfig>>;
  configuration?: {
    hiddenApps?: string[];
  };
  users?: {
    hiddenRules?: string[];
  };
  hotel?: {
    hiddenRoomMedia?: string[];
    roomLevelAsCategory?: boolean;
  };
  staff?: {
    musterRollAsPositions?: boolean;
  };
  menu?: {
    hideBarsManagement?: boolean;
    hideHistory?: boolean;
  };
  roomService?: {
    hiddenServiceTypes?: string[];
  };
  settings?: {
    hiddenOptions?: string[];
  };
  faq?: {
    hidden?: boolean;
  };
  header?: {
    hideBigNavbar?: boolean;
  };
  guideProfile?: string;
}

const emptyConfig: IHostFeatureConfig = {};

const tmh1Config: IHostFeatureConfig = {
  navbar: {
    orders: { hidden: true },
    timetable: { hidden: true },
    map: { hidden: true },
    routes: { singleChild: "RouteInfoV2Page" },
    services: { singleChild: "MenuList" },
    hotel: {
      hiddenChildren: ["HotelInfoList", "RestorantsConstructior"],
    },
    media: {
      hiddenChildren: [
        "AudioFTP",
        "PaintingModeList",
        "GalleryFTP",
        "GalleryPage",
      ],
    },
  },
  hotel: {
    hiddenRoomMedia: ["main_photo", "room_plan", "fire_plan"],
    roomLevelAsCategory: true,
  },
  staff: {
    musterRollAsPositions: true,
  },
  configuration: {
    hiddenApps: ["mobile", "sign"],
  },
  users: {
    hiddenRules: ["signuser", "user"],
  },
  menu: {
    hideBarsManagement: true,
    hideHistory: true,
  },
  roomService: {
    hiddenServiceTypes: [
      "HYGIENE_SUPPLIES",
      "CLEANING_REQUEST",
      "DO_NOT_DISTURB",
      "EMERGENCY_ASSISTANCE",
    ],
  },
  settings: {
    hiddenOptions: ["reviews", "consents"],
  },
  header: {
    hideBigNavbar: true,
  },
  guideProfile: "tmh1",
};

export const hostFeatureConfigMap: Partial<Record<Hosts, IHostFeatureConfig>> =
  {
    [Hosts.ТМХ_1]: tmh1Config,
    [Hosts.ТМХ_1_glob]: tmh1Config,
    // [Hosts.data_center]: tmh1Config,
  };

export function getHostFeatureConfigByKey(hostKey: Hosts): IHostFeatureConfig {
  return hostFeatureConfigMap[hostKey] || emptyConfig;
}
